import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmVariant = 'primary', // primary, danger
  isLoading = false,
}) => {
  if (!isOpen) return null;

  const confirmButtonClasses = {
    primary: 'btn-primary',
    danger: 'btn-danger',
  };

  return (
    <>
      <div className="modal-backdrop" onClick={onClose} />
      <div className="modal">
        <div className="modal-content animate-slide-up">
          <div className="p-6">
            <div className="flex items-start gap-4">
              <div className={`p-3 rounded-full ${confirmVariant === 'danger' ? 'bg-red-500/20' : 'bg-primary-500/20'}`}>
                <ExclamationTriangleIcon className={`w-6 h-6 ${confirmVariant === 'danger' ? 'text-red-400' : 'text-primary-400'}`} />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-white">{title}</h3>
                <p className="mt-2 text-sm text-slate-400">{message}</p>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-800">
            <button
              type="button"
              onClick={onClose}
              disabled={isLoading}
              className="btn-secondary"
            >
              {cancelText}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={isLoading}
              className={confirmButtonClasses[confirmVariant]}
            >
              {isLoading ? (
                <span className="flex items-center gap-2">
                  <div className="spinner w-4 h-4" />
                  Processing...
                </span>
              ) : (
                confirmText
              )}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmModal;
